// eslint-disable-next-line no-restricted-imports
import {
  CreateOrderByAdminDto_Input,
  MutationInput_OrderController_CreateOne_Input_OperationType,
  MutationInput_OrderController_CreateOne_Input_OwnerType,
  Query_OrderController_GetById_ExecutionTerms_OperationKind,
  Query_OrderController_GetById_ExecutionTerms_OrderType,
} from 'api/generated/graphql';
import { CreateOrderParams } from 'api/types/params';
import { formatToISODate } from 'helpers';

export const parseCreateOrderParams = (
  params: CreateOrderParams
): CreateOrderByAdminDto_Input => ({
  ownerId: params.ownerId,
  ownerType:
    MutationInput_OrderController_CreateOne_Input_OwnerType[params.ownerType],
  startDate: params.startDate ? formatToISODate(params.startDate) : undefined,
  endDate: formatToISODate(params.endDate),
  executionPeriodInBusinessDays: params.executionPeriodInBusinessDays,
  executionTerms: {
    additionalNotes: params.executionTerms.additionalNotes,
    orderType: params.executionTerms.orderType
      ? Query_OrderController_GetById_ExecutionTerms_OrderType[
          params.executionTerms.orderType
        ]
      : undefined,
    yield: params.executionTerms.yield,
    operationKind: params.executionTerms.operationKind
      ? Query_OrderController_GetById_ExecutionTerms_OperationKind[
          params.executionTerms.operationKind
        ]
      : undefined,
    operationPurpose: params.executionTerms.operationPurpose,
  },
  financialInstrument: {
    isin: params.financialInstrument.isin,
    securityType: params.financialInstrument.securityType,
    issuer: params.financialInstrument.issuer,
    nominalValue: params.financialInstrument.nominalValue,
  },

  transactionVolume: params.transactionVolume
    ? {
        quantity: params.transactionVolume.quantity,
        unitPrice: params.transactionVolume.unitPrice,
        currency: params.transactionVolume.currency,
        transactionAmount: params.transactionVolume.transactionAmount,
      }
    : undefined,

  transferVolume: params.transferVolume
    ? {
        quantity: params.transferVolume.quantity,
        unitPrice: params.transferVolume.unitPrice,
        currency: params.transferVolume.currency,
        transactionAmount: params.transferVolume.transactionAmount,
      }
    : undefined,

  senderDetails: params.senderDetails
    ? {
        accountNumber: params.senderDetails.accountNumber,
        brokerName: params.senderDetails.brokerName,
        custodianOrganization: params.senderDetails.custodianOrganization,
        accountOwnerName: params.senderDetails.accountOwnerName,
        custodianOrganizationCode:
          params.senderDetails.custodianOrganizationCode,
      }
    : undefined,

  recipientDetails: params.recipientDetails
    ? {
        accountNumber: params.recipientDetails.accountNumber,
        brokerName: params.recipientDetails.brokerName,
        custodianOrganization: params.recipientDetails.custodianOrganization,
        accountOwnerName: params.recipientDetails.accountOwnerName,
        custodianOrganizationCode:
          params.recipientDetails.custodianOrganizationCode,
      }
    : undefined,

  additionalParameters: params.additionalParameters
    ? {
        settlementDate: params.additionalParameters.settlementDate
          ? formatToISODate(params.additionalParameters.settlementDate)
          : null,
        transactionDate: params.additionalParameters.transactionDate
          ? formatToISODate(params.additionalParameters.transactionDate)
          : null,
      }
    : undefined,

  confirmationDocument: params.confirmationDocument
    ? {
        fileIds: params.confirmationDocument.fileIds,
        contractDate: params.confirmationDocument.contractDate
          ? formatToISODate(params.confirmationDocument.contractDate)
          : undefined,
        contractNumber: params.confirmationDocument.contractNumber,
      }
    : undefined,

  operationType:
    MutationInput_OrderController_CreateOne_Input_OperationType[
      params.operationType
    ],
});
